import { Popconfirm, Tag, notification } from "antd";
import { useEffect, useState } from "react";
import TicketsService from "../../services/http/services/TicketsService";
import { FaTrashAlt } from "react-icons/fa";
import useAuth from "../../hooks/useAuth";

interface TicketTagsProps {
  tickets: number[];
}

export function TicketTags({ tickets }: TicketTagsProps) {
  const [ticketList, setTicketList] = useState<number[]>([]);
  const [loadingId, setLoadingId] = useState<number | null>(null);
  const { user } = useAuth();
  const isAdmin = user?.role?.id === 1;

  useEffect(() => {
    setTicketList(tickets);
  }, [tickets]);

  async function handleRemove(ticketId: number) {
    try {
      setLoadingId(ticketId);

      await TicketsService.delete(ticketId);

      setTicketList((prev) => prev.filter((id) => id !== ticketId));

      notification.success({
        message: "Bilhete removido com sucesso.",
      });
    } catch {
      notification.error({
        message: "Não foi possível remover o bilhete.",
      });
    } finally {
      setLoadingId(null);
    }
  }

  if (ticketList.length === 0) {
    return (
      <Tag color="default" bordered={false} style={{ color: "#8c8c8c" }}>
        0 Bilhetes
      </Tag>
    );
  }

  return (
    <>
      {ticketList.map((ticketId) => (
        <Popconfirm
          key={ticketId}
          title="Excluir bilhete?"
          disabled={!isAdmin}
          description={`Deseja remover o bilhete ${ticketId}?`}
          okText="Excluir"
          cancelText="Cancelar"
          onConfirm={() => handleRemove(ticketId)}
        >
          <Tag
            color="red"
            onClose={(e) => e.preventDefault()}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              padding: "2px 6px",
              borderRadius: 2,
              marginBottom: 6,
              borderStyle: "dashed",
              cursor: "pointer",
              userSelect: "none",
              transition: "all .2s ease",
              opacity: loadingId === ticketId ? 0.5 : 1,
              fontWeight: 500,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#ffede6";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "";
              e.currentTarget.style.transform = "";
            }}
          >
            <span>{ticketId}</span>

            {isAdmin && <FaTrashAlt
              size={11}
              color="#ff4d4f"
              style={{ marginLeft: 2 }}
            />}
          </Tag>
        </Popconfirm>
      ))}
    </>
  );
}